T.GameFlow = Class(
	/**
	 * @lends {T.GameFlow#}
	 */
	{
		__construct() {
			let experiences = [];
			for( let i = 0; i < 8; i++ ){
				experiences.push({
					tag: 'li',
					text: D.Lang.get('home.experiences.experiences.' + i)
				});
			}
			this.node = mkE({
				tag: 'div',
				id: 'experience',
				className: 'container',
				els: [
					{
						tag: 'div',
						className: 'experience-info',
						els: [
							{
								tag: 'div',
								className: 'caption',
								text: D.Lang.get('home.experiences.caption')
							},
							{
								tag: 'h2',
								className: 'h1',
								text: D.Lang.get('home.experiences.title')
							},
							{
								tag: 'p',
								className: 'color-dark',
								text: D.Lang.get('home.experiences.text')
							},
							{
								tag: 'ul',
								className: 'default-list',
								els: experiences
							}
						]
					}
				]
			});
		}
	},
	mkE.Base
)